/** Client logo rotation — white marks from the Simple Icons CDN. Each set fills the 5-up row; sets cycle. */
export interface ClientLogo {
  name: string;
  slug: string;
}

export const logoSets: ClientLogo[][] = [
  [
    { name: 'Activision', slug: 'activision' },
    { name: 'Slack', slug: 'slack' },
    { name: 'Audi', slug: 'audi' },
    { name: 'Salesforce', slug: 'salesforce' },
    { name: 'Visa', slug: 'visa' },
  ],
  [
    { name: 'Samsung', slug: 'samsung' },
    { name: 'Netflix', slug: 'netflix' },
    { name: 'Tesla', slug: 'tesla' },
    { name: 'Porsche', slug: 'porsche' },
    { name: 'eBay', slug: 'ebay' },
  ],
  [
    { name: 'Sony', slug: 'sony' },
    { name: 'Intel', slug: 'intel' },
    { name: 'FedEx', slug: 'fedex' },
    { name: 'Adidas', slug: 'adidas' },
    { name: 'Uber', slug: 'uber' },
  ],
  [
    { name: 'Mastercard', slug: 'mastercard' },
    { name: 'Nike', slug: 'nike' },
    { name: 'Airbnb', slug: 'airbnb' },
    { name: 'Spotify', slug: 'spotify' },
    { name: 'Lego', slug: 'lego' },
  ],
  [
    { name: 'Google', slug: 'google' },
    { name: 'Apple', slug: 'apple' },
    { name: 'BMW', slug: 'bmw' },
    { name: 'Shopify', slug: 'shopify' },
    { name: 'Discord', slug: 'discord' },
  ],
];

export const logoUrl = (slug: string) => `https://cdn.simpleicons.org/${slug}/white`;
